import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Typography } from 'antd';
import cn from 'classnames';
import dayjs from 'dayjs';

import { parseNegativeNumber } from '../../lib/parse-negative-number';
import { useGetTradingPlatformSessionCurrency } from '../../models/selectors/get-trading-platform-session-currency';

import cls from './trading-platform-daily-info-title.module.css';

interface TradingPlatformDailyInfoTitleProps {
    date: string;
    dailyNetPL: number;
}

export const TradingPlatformDailyInfoTitle = memo(
    (props: TradingPlatformDailyInfoTitleProps) => {
        const { date, dailyNetPL } = props;

        const { t } = useTranslation('trading-journal');

        const currency = useGetTradingPlatformSessionCurrency();

        return (
            <Flex
                align="center"
                className={cls.root}
                gap={8}
            >
                <Typography.Text>
                    {dayjs(date).format('ddd, MMM DD, YYYY')}
                </Typography.Text>
                <Typography.Text>•</Typography.Text>
                <Typography.Text
                    className={cn(cls.netValue, { [cls.loss]: dailyNetPL < 0 })}
                >
                    {t('tradingJournalDailyInfoTitlePrefix')}
                    {parseNegativeNumber(dailyNetPL, currency)}
                </Typography.Text>
            </Flex>
        );
    },
);

TradingPlatformDailyInfoTitle.displayName = 'TradingPlatformDailyInfoTitle';
